import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api/auth";

export default function ProfileGuard({
  children,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] =
    useState(true);

  const [showPopup, setShowPopup] =
    useState(false);

  useEffect(() => {
    // ✅ DO NOTHING ON SETTINGS PAGE
    if (location.pathname === "/settings") {
      setLoading(false);
      return;
    }

    checkProfile();
  }, [location.pathname]);

  const calculateCompletion = (data) => {
    const fields = [
      "businessName",
      "gstNumber",
      "phone",
      "email",
      "address",
      "city",
      "state",
      "pincode",
      "logoUpload",
      "invoiceTemplate",
    ];

    const filled = fields.filter(
      (k) => data[k]?.toString().trim()
    ).length;

    return Math.round(
      (filled / fields.length) * 100
    );
  };

  const checkProfile = async () => {
    try {
      const res = await api.get(
        "/api/user/business"
      );

      const b = res.data.business;

      if (!b) {
        setShowPopup(true);
        return;
      }

      const profileData = {
        businessName: b.name || "",
        gstNumber: b.gstin || "",
        phone: b.phone || "",
        email: b.email || "",
        address: b.address || "",
        city: b.city || "",
        state: b.state || "",
        pincode: b.pincode || "",
        logoUpload: b.logoUpload || "",
        invoiceTemplate:
          b.invoiceTemplate || "",
      };

      const completion =
        calculateCompletion(profileData);

      if (completion < 90) {
        setShowPopup(true);
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

 if (loading) {
  return (
    <div style={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center"
    }}>
      Loading...
    </div>
  );
}

  return (
    <>
      {showPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background:
              "rgba(0,0,0,0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: 30,
              borderRadius: 20,
              width: 350,
              textAlign: "center",
            }}
          >
            <h2
              style={{
                marginBottom: 10,
              }}
            >
              Complete Profile
            </h2>

            <p
              style={{
                color: "#666",
                marginBottom: 20,
              }}
            >
              Please complete your
              profile before using
              dashboard features.
            </p>

            <button
              onClick={() => {
                setShowPopup(false);
                navigate("/settings");
              }}
              style={{
                background: "#2d2b69",
                color: "white",
                border: "none",
                padding:
                  "12px 18px",
                borderRadius: 10,
                cursor: "pointer",
                width: "100%",
                fontWeight: 600,
              }}
            >
              Complete Profile
            </button>
          </div>
        </div>
      )}

      {!showPopup && children}
    </>
  );
}